import apiService from '../apiService';

const MATTER_URL = 'matters'
const matterService = {

    async createMatter(payload) {
        try {
            const response = await apiService.post(`/${MATTER_URL}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async getAllMatters(params = {}) {
        try {
            const queryParams = new URLSearchParams(params).toString();
            const response = await apiService.get(`/${MATTER_URL}${queryParams ? `?${queryParams}` : ''}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async getSingleMatter(id) {
        try {
            const response = await apiService.get(`/${MATTER_URL}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async updateMatter(payload, id) {
        try {
            const response = await apiService.put(`/${MATTER_URL}/${id}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    // One partial update for many matters (OL-138): { ids, ...changes }.
    // Move a matter to another stage of its record type (OL-209).
    async updateStage(id, stageId) {
        try {
            const response = await apiService.patch(`/${MATTER_URL}/${id}/stage`, { stage_id: stageId });
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async bulkUpdateMatters(payload) {
        try {
            const response = await apiService.patch(`/${MATTER_URL}/bulk`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async deleteMatter(id) {
        try {
            const response = await apiService.delete(`/${MATTER_URL}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async exportMatter() {
        try {
            const response = await apiService.get(`/${MATTER_URL}/export`, {
                responseType: 'blob'
            });
            console.log(response.data.text())
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async importMatter(payload) {
        try {
            const response = await apiService.post(`/${MATTER_URL}/import`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async matterSampleFile() {
        try {
            const response = await apiService.get(`/${MATTER_URL}/sample`, {
                responseType: "blob"
            });
            return response;
        } catch (error) {
            console.log(error)
            throw error.response.data;
        }
    },

    async requestFileUpload(id, payload) {
        try {
            const response = await apiService.post(`/${MATTER_URL}/sendDocUploadLink/${id}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    // async uploadDocForSignature(payload) {
    //     try {
    //         const response = await apiService.post(`/documents/upload`, payload);
    //         return response.data;
    //     } catch (error) {
    //         throw error.response;
    //     }
    // },

};

export default matterService;